import { Button } from '@heathmont/moon-components';
import type { ColorNames } from '@heathmont/moon-themes';
import ControlsClose from '@/external/icons/ControlsClose';

type Props = {
  color?: ColorNames;
  fontSize?: number;
  onClick: () => void | Promise<boolean>;
};

const CloseButton: FC<Props> = ({
  color = 'trunks.100',
  fontSize = 24,
  onClick,
}) => (
  <Button onClick={onClick}>
    <ControlsClose fontSize={fontSize} color={color} />
  </Button>
);

export default CloseButton;
